import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import { setAdminUnauthorizedHandler } from './services/http';
import './styles/global.css';

Vue.config.productionTip = false;
Vue.use(ElementUI);

setAdminUnauthorizedHandler(() => {
  const currentRoute = router.currentRoute;

  if (currentRoute.path === '/admin/login') {
    return;
  }

  router.replace({
    path: '/admin/login',
    query: {
      redirect: currentRoute.fullPath,
    },
  });
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
